export default {
    setFeedAttachment(state, payload) {
        state.feedAttachment = payload;
    }
}